import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useAemConfig } from '@as-react/common-components';
import { I18N_NAMESPACES } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { loadFeefoScript } from '../../util/ReviewUtil';
var FeefoOpenMode;
(function (FeefoOpenMode) {
    FeefoOpenMode["TAB"] = "tab";
    FeefoOpenMode["POPUP"] = "popup";
})(FeefoOpenMode || (FeefoOpenMode = {}));
const FEEFO_POPUP_TRIGGER_ID = 'feefologohere';
const FeefoBrandBadge = ({ openMode = FeefoOpenMode.TAB }) => {
    const { review: { feefoIdentifier }, } = useAemConfig();
    const { t } = useTranslation(I18N_NAMESPACES.general);
    useEffect(() => {
        if (openMode === FeefoOpenMode.POPUP && feefoIdentifier) {
            loadFeefoScript(feefoIdentifier);
        }
    }, [openMode]);
    if (!feefoIdentifier)
        return null;
    return openMode === FeefoOpenMode.TAB ? (_jsx("a", { href: `https://www.feefo.com/reviews/${feefoIdentifier}`, target: "_blank", rel: "noreferrer", children: _jsx("div", { id: FEEFO_POPUP_TRIGGER_ID, children: _jsx("img", { alt: "Feefo logo", src: `https://api.feefo.com/api/logo?merchantidentifier=${feefoIdentifier}`, title: t(`${I18N_NAMESPACES.general}:review.feefo.title`) }) }) })) : (_jsx("div", { id: FEEFO_POPUP_TRIGGER_ID }));
};
export default FeefoBrandBadge;
